export const deliverySettings = {
	title: "Configurar Delivery e Integrações",
	description: "Integre com um Delivery parceiro e centralize sua gestão na Zig.",
	integrateButton: "Nova integração",
	tabs: {
		management: "Gestão de integrações",
		integrate: "Integrar delivery",
		configuration: "Configurações",
	},
	integrate: {
		steps: {
			systemLabel: "Selecionar sistema de integração",
			authLabel: "Autenticar integração",
			syncMenuLabel: "Sincronizar cardápio",
			systemAndAuth: {
				titleSystemIntegration: "Sistema de integração",
				titleAuth: "Autenticação no sistema parceiro",
				descriptionIFood: "Cole aqui sua Chave de API disponibilizada pelo IFood.",
				descriptionAuthRappi: "Cole aqui sua Chave de API disponibilizada pelo Rappi.",
				descriptionKeeta: "Clique em 'Autorizar integração' para conectar com o Keeta.",
				descriptionFood99: "Clique em 'Autorizar integração' para conectar com o 99Food.",
				labelSelect: "Selecione com quem vamos integrar",
				labelInput: "ID da loja",
				labelCNPJ: "CNPJ da loja",
				errorCNPJRequired: "CNPJ é obrigatório",
				placeholderInputIFood: "Cole aqui o código copiado do iFood",
				placeholderInputRappi: "Cole aqui o código copiado do Rappi",
				placeholderInput: "Cole aqui o código",
				placeholderCNPJ: "Digite o CNPJ",
				submitButton: "Seguir com integração",
				authorizeButton: "Autorizar integração",
				buttonAddMore: "Adicionar mais uma loja",
				avisoTitle: "Precisamos de autorização para integrar com a Rappi",
				avisoDescription:
					"Envie uma solicitação para nosso atendimento que entraremos em contato para seguir com o processo de integração.",
				iFoodDialog: {
					title: "Precisamos de autorização para integrar",
					description:
						"Para seguirmos com a integração com o iFood, é necessário sua confirmação de solicitação. Para isso, você deve acessar o sistema e gerar uma Chave de API. Quando copiar a Chave do iFood, retorne para seguir com a integração.",
					cancelButton: "Cancelar integração",
					openButton: "Abrir iFood",
				},
				keetaDialog: {
					title: "Autenticação no sistema parceiro",
					heading: "Estamos quase lá!",
					descriptionBefore: 'Ao clicar em "',
					descriptionBold: "autorizar integração",
					descriptionAfter:
						'", você será direcionado para a plataforma do Keeta e confirmará a autorização.',
					cancelButton: "Cancelar",
					authorizeButton: "Autorizar integração",
				},
				food99Dialog: {
					title: "Integração com 99Food",
					heading: "Informe o ID da sua loja",
					description:
						'Acesse o painel do 99Food Admin, vá em "Informações da loja" e copie o ID.',
					inputPlaceholder: "ID da loja (ex: 5764615004067727796)",
					bindButton: "Vincular",
					closeButton: "Fechar",
					notAuthorizedToggle: "A loja ainda não foi autorizada?",
					notAuthorizedDescription:
						"Gere um link de autorização e envie ao lojista. Após ele autorizar no painel do 99Food, volte aqui e tente vincular de novo.",
					generateLinkButton: "Gerar link",
					urlPlaceholder: "Link de autorização",
					copyButton: "Copiar",
					urlCopied: "Link copiado!",
					urlCopyFailed: "Falha ao copiar",
				},
			},
			syncMenu: {
				title: "Em breve você poderá importar seu cardápio!",
				descriptionIFood:
					"Em algumas semanas você poderá importar seu cardápio do iFood e usá-lo também no nosso sistema.",
				descriptionRappi:
					"Em algumas semanas você poderá importar seu cardápio do Rappi e usá-lo também no nosso sistema.",
				syncOffMenuButton: "Concluir integração sem cardápio",
				syncPending: {
					title: "Traga seu cardápio pra Zig",
					description:
						"Associe o seu cardápio do {{externalStoreType}} com os produtos cadastrados na Zig e tenha uma gestão centralizada.",
					syncMenuButton: "Sincronizar cardápio do {{externalStoreType}}",
					syncLate: "Sincronizar depois",
				},
				importPending: {
					title: "Traga seu cardápio pra Zig",
					description:
						"Você pode importar seu cardápio do {{externalStoreType}} e usá-lo também no nosso sistema.",
					syncMenuButton: "Importar cardápio do {{externalStoreType}}",
					completeWithoutMenu: "Concluir integração sem cardápio",
				},
			},
		},
	},
	management: {
		newMerchantTitle: "Adicionar nova loja",
		newMerchantButton: "Adicionar loja",
		labelInput: "ID da loja",
		integrationDescription: "Integração via API",
		integrationDescriptionWithDate: "Integração via API - {{date}}",
		removeIntegration: "Remover integração",
		saveChanges: "Salvar alterações",
		backToImport: "Continuar Importação",
		syncMenu: "Continuar Sincronização",
		validateAndLink: "Validar e Vincular",
		merchants: "Lojas",
		active: "Ativo",
		activeIntegration: "Ativar Integração ",
		disableIntegration: "Desativar integração",
		integrationSuccess: "Integração atualizada com sucesso",
		integrationError: "Erro ao atualizar a integração. Por favor, tente novamente.",
		awaitIntegration: "Aguardando integração",
		notAuthorizedStoreTitle: "Integração da loja ainda não foi autorizada",
		notAuthorizedStoreDescription:
			"Gere um link para ser direcionado para a plataforma e confirmar a autorização",
		linkPlaceholder: "O link aparecerá aqui",
		generateLinkButton: "Gerar link",
		authorizeLinkButton: "Autorizar",
		removeIntegrationModal: {
			button: "Remover integração",
			title: "Remover integração",
			description: "Tem certeza que deseja remover as integrações?",
			okText: "Confirmar",
			cancelText: "Cancelar",
		},
		emptyState: {
			title: "Ainda não tem nada por aqui",
			description: "Parece que você ainda não tem um delivery integrado.",
			button: "Integrar um Delivery",
		},
	},
	coalaConfig: {
		emptyState: {
			title: "Ainda não tem nada por aqui",
			description: "Parece que você ainda não tem cardápios para configurar.",
		},
	},
};
